import { render } from "./ProfileMarkCourseContent.vue?vue&type=template&id=77f89d53&scoped=true"
import script from "./ProfileMarkCourseContent.vue?vue&type=script&lang=js"
export * from "./ProfileMarkCourseContent.vue?vue&type=script&lang=js"

import "./ProfileMarkCourseContent.vue?vue&type=style&index=0&id=77f89d53&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f89d53"]])

export default __exports__